import { Zap } from 'lucide-react'
import type { SpeedTier } from '@fuelfinder/shared'

interface SpeedTierToggleProps {
  value: SpeedTier | 'all'
  onChange: (value: SpeedTier | 'all') => void
}

const OPTIONS: { value: SpeedTier | 'all'; label: string; bolts: number }[] = [
  { value: 'all', label: 'All', bolts: 0 },
  { value: 'slow', label: '≤7kW', bolts: 1 },
  { value: 'fast', label: '7-50kW', bolts: 2 },
  { value: 'rapid', label: '50kW+', bolts: 3 },
]

/**
 * Render lightning bolt icons for a speed tier
 */
function BoltIcons({ count }: { count: number }) {
  if (count === 0) return null
  return (
    <span className="inline-flex mr-1">
      {Array.from({ length: count }, (_, i) => (
        <Zap key={i} size={12} className="fill-current -ml-0.5 first:ml-0" />
      ))}
    </span>
  )
}

/**
 * Speed tier toggle for filtering chargepoints by power level
 * Replaces the old Petrol/Diesel fuel type toggle
 */
export function SpeedTierToggle({ value, onChange }: SpeedTierToggleProps) {
  return (
    <div className="flex bg-slate-200 dark:bg-slate-700 rounded-lg p-1">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`flex-1 py-2 px-2 rounded-md text-xs font-medium transition-colors flex items-center justify-center ${
            value === option.value
              ? 'bg-brand-500 text-white shadow-sm'
              : 'text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white'
          }`}
          aria-pressed={value === option.value}
        >
          <BoltIcons count={option.bolts} />
          {option.label}
        </button>
      ))}
    </div>
  )
}
